import { Action } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import * as Objects from '@core/objects';
import { AddRequest, AddProjectErrors } from '@app/models/add-project';


export enum AddProjectActionType {
    InitAddProject = "[AddProject] Initialize new project data",
    UpdateAddProject = "[AddProject] Update new project data",
    Clear = "[AddProject] Clear data",
    SetErrors = "[AddProject] Set error flags",
    ClearErrors = "[AddProject] Clear error flags",
    SubmitAddProject = "[AddProject] Submit new project",           // New action
    SubmitAddProjectSuccess = "[AddProject] Submit new project success", // New action
    SubmitAddProjectFailure = "[AddProject] Submit new project failure"  // New action
}

export class InitAddProject implements Action {
    readonly type = AddProjectActionType.InitAddProject;
    constructor(public workflowId: number, public versionId: number | null) {}
}

export class UpdateAddProject implements Action {
    readonly type = AddProjectActionType.UpdateAddProject;
    constructor(public property: Partial<AddRequest>) {}
}

export class Clear implements Action {
    readonly type = AddProjectActionType.Clear;
    constructor() {}
}

export class SetErrors implements Action {
    readonly type = AddProjectActionType.SetErrors;
    constructor(public errors: Partial<AddProjectErrors>) {}
}

export class ClearErrors implements Action {
    readonly type = AddProjectActionType.ClearErrors;
    constructor() {}
}

export class SubmitAddProject implements Action {
    readonly type = AddProjectActionType.SubmitAddProject;
    constructor(public payload: AddRequest) {}
}

export class SubmitAddProjectSuccess implements Action {
    readonly type = AddProjectActionType.SubmitAddProjectSuccess;
    constructor( public project: Objects.Request) {}
}

export class SubmitAddProjectFailure implements Action {
    readonly type = AddProjectActionType.SubmitAddProjectFailure;
    constructor(public error: HttpErrorResponse) {}
}

export type AddProjectActions =
        | InitAddProject
        | UpdateAddProject
        | Clear
        | SetErrors
        | ClearErrors
        | SubmitAddProject
        | SubmitAddProjectSuccess
        | SubmitAddProjectFailure;